module.exports = __webpack_public_path__ + "f28e97b6a8fe110f7b21a612b458f31f.jpg";